import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/completed.png'
import _imports_1 from '@/assets/images/round.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-underline" }, "ピックアップ動画", -1)
const _hoisted_2 = { class: "sm:masonry-2-col lg:masonry-3-col" }
const _hoisted_3 = {
  key: 0,
  class: "break-inside rounded overflow-hidden mb-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bg-tradelaboBlue py-2" }, null, -1)
const _hoisted_5 = { class: "p-1 bg-white" }
const _hoisted_6 = { class: "p-3 border-gray-300" }
const _hoisted_7 = { class: "font-medium text-gray-700" }
const _hoisted_8 = { class: "grid grid-cols-12 py-3" }
const _hoisted_9 = { class: "col-span-2 flex items-center justify-center" }
const _hoisted_10 = {
  key: 0,
  class: "w-7",
  src: _imports_0,
  alt: "済"
}
const _hoisted_11 = {
  key: 1,
  class: "w-7",
  src: _imports_1,
  alt: "未済"
}
const _hoisted_12 = { class: "col-span-10 flex items-center" }
const _hoisted_13 = { class: "font-medium text-gray-500 truncate" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.toArray(_ctx.videoCategories).length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoCategories, (category) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: category.id
            }, [
              (_ctx.toArray(category.videos).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(category.name), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.videos, (video) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: video.id,
                          class: "border-gray-300 border-t hover:bg-gray-100"
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/video/${video.id}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  (_ctx.toArray(video.video_watch_completions).length)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                                    : (_openBlock(), _createElementBlock("img", _hoisted_11))
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(video.title), 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ], 64))
    : _createCommentVNode("", true)
}